/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-25 10:06:15
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-28 09:30:54
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\Future\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
import { lang } from "moment";
function Future() {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const futureCenter = t("solution_infoServices.infoServices2", {
    returnObjects: true,
  });
  return (
    <div className="future_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{futureCenter.til}</div>
          <span>{futureCenter.dil}</span>
        </div>
      </div>
      <div className="future_con">
        {futureCenter.contractList.map((item0, index0) => {
          return (
            <div className="future_li" key={index0}>
              <div className="future_li_heard" style={language === "zh"?{height: ''}:{height: '190px'}}>
                <div className="future_li_heard_title">{item0.title}</div>
                <div className="future_li_heard_con">{item0.detail}</div>
              </div>
              <ul className="future_li_body">
                {item0.list.map((item1, index1) => {
                  return (
                    <li className="future_li_con" key={index0 + index1}>
                      <div className="li_left">
                        <img src={item1.imgUrl} alt="" />
                      </div>
                      <div className="li_right">
                        <div className="right_top">{item1.text}</div>
                        <div className="right_bottom">{item1.detail}</div>
                        </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Future;
